// 回单反查任务管理
import request from '@/utils/http';

// 列表数据
export const receiptRecheckTaskQuery = (params) => {
    return request({
        url: `/api-tms/receipt/recheck/task/query`,
        method: 'get',
        params
    });
};

// 回单印鉴
export const queryByTaskNo = (params) => {
    return request({
        url: `/api-tms/receipt/registration/queryByTaskNo`,
        method: 'get',
        params
    });
};

// 回单附件
export const searchreceiptfilebytasknos = (params) => {
    return request({
        url: `/api-tms/receipt/searchreceiptfilebytasknos`,
        method: 'post',
        data: params
    });
};

// 反查记录
export const recordQuery = (params) => {
    return request({
        url: `/api-tms/receipt/recheck/record/query`,
        method: 'get',
        params
    });
};

// 回单反查 保存
export const recordSave = (params) => {
    return request({
        url: `/api-tms/receipt/recheck/record/save`,
        method: 'post',
        data: params
    });
};

// 签收中心 反查 保存
export const saveFromSignCenter = (params) => {
    return request({
        url: `/api-tms/receipt/recheck/record/saveFromSignCenter`,
        method: 'post',
        data: params
    });
};

// 回单反查 附件查询
export const fileQuery = (params) => {
    return request({
        url: `/api-tms/receipt/recheck/record/file/query`,
        method: 'get',
        params
    });
};

// 回单反查 附件删除
export const fileDelete = (params) => {
    return request({
        url: `/api-tms/receipt/recheck/record/file/delete/${params}`,
        method: 'delete'
    });
};

// 回单反查 附件上传
export const fileSave = (params) => {
    return request({
        url: `/api-tms/receipt/recheck/record/file/save`,
        method: 'post',
        data: params
    });
};

export default {
    receiptRecheckTaskQuery,
    queryByTaskNo,
    searchreceiptfilebytasknos,
    recordQuery,
    recordSave,
    saveFromSignCenter,
    fileQuery,
    fileDelete,
    fileSave
};
